import NoteboardEditor from './NoteboardEditor';

export default NoteboardEditor;
